exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-wrap:before{content:\"\";width:200%;height:200%;margin:-50px;z-index:1;position:absolute;top:0;background:url(/img/video-halftone-overlay.png),linear-gradient(180deg,rgba(0,0,0,.43) 0,rgba(0,0,0,.52) 5%,rgba(0,0,0,.1) 10%,rgba(0,0,0,.64) 46%,rgba(0,0,0,.19))}", ""]);

// exports
